import { useState } from 'react';
import { Modal, Button, Form} from 'react-bootstrap';
import { FaCalendarAlt, FaInfoCircle } from 'react-icons/fa';

const ReportPeriodModal = ({ show, onClose, onGenerate, accountName }) => {
  const [periodOption, setPeriodOption] = useState('3months'); // '3months', 'custom', 'specific'
  const [customMonths, setCustomMonths] = useState(3);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleGenerate = () => {
    let periodValue = null;
    
    if (periodOption === '3months') {
      periodValue = 3; // Les 3 derniers mois
    } else if (periodOption === 'custom') {
      periodValue = customMonths; // Nombre personnalisé de mois
    } else if (periodOption === 'specific') {
      // Calculer le nombre de mois entre startDate et aujourd'hui
      if (startDate) {
        const start = new Date(startDate);
        const today = new Date();
        const monthsDiff = (today.getFullYear() - start.getFullYear()) * 12 + 
                          (today.getMonth() - start.getMonth());
        periodValue = Math.max(1, monthsDiff);
      }
    }
    
    onGenerate(periodValue);
  };

  const getPeriodDescription = () => {
    switch(periodOption) {
      case '3months':
        return "Les 3 derniers mois (recommandé)";
      case 'custom':
        return `Les ${customMonths} derniers mois`;
      case 'specific':
        return startDate ? 
          `Du ${new Date(startDate).toLocaleDateString()} à aujourd'hui` : 
          "Sélectionnez une date de début";
      default:
        return "";
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FaCalendarAlt className="me-2" />
          Configurer le relevé de compte
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-3">
          Pour le compte : <strong>{accountName}</strong>
        </p>
        
        <div className="alert alert-info">
          <FaInfoCircle className="me-2" />
          <small>
            <strong>Note :</strong> Si aucune période n'est spécifiée, 
            le relevé couvrira automatiquement les 3 derniers mois.
          </small>
        </div>
        
        <Form>
          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Période du relevé</Form.Label>
            
            <div className="mb-3">
              <Form.Check
                type="radio"
                id="period-3months"
                label="3 derniers mois (par défaut)"
                name="periodOption"
                checked={periodOption === '3months'}
                onChange={() => setPeriodOption('3months')}
                className="mb-2"
              />
              
              <Form.Check
                type="radio"
                id="period-custom"
                label="Nombre personnalisé de mois"
                name="periodOption"
                checked={periodOption === 'custom'}
                onChange={() => setPeriodOption('custom')}
                className="mb-2"
              />
              
              {periodOption === 'custom' && (
                <div className="ms-4 mt-2">
                  <Form.Control
                    type="number"
                    min="1"
                    max="36"
                    value={customMonths}
                    onChange={(e) => setCustomMonths(parseInt(e.target.value) || 1)}
                    style={{ width: '100px' }}
                  />
                  <Form.Text className="text-muted">
                    Nombre de mois à remonter (1 à 36)
                  </Form.Text>
                </div>
              )}
              
              <Form.Check
                type="radio"
                id="period-specific"
                label="Depuis une date spécifique"
                name="periodOption"
                checked={periodOption === 'specific'}
                onChange={() => setPeriodOption('specific')}
                className="mb-2"
              />
              
              {periodOption === 'specific' && (
                <div className="ms-4 mt-2">
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    max={new Date().toISOString().split('T')[0]}
                  />
                  <Form.Text className="text-muted">
                    Date de début (jusqu'à aujourd'hui)
                  </Form.Text>
                </div>
              )}
            </div>
          </Form.Group>
          
          <div className="bg-light p-3 rounded mb-3">
            <small className="text-muted d-block mb-1">
              <strong>Résumé :</strong>
            </small>
            <div className="fw-semibold">
              {getPeriodDescription()}
            </div>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Annuler
        </Button>
        <Button variant="primary" onClick={handleGenerate}>
          Générer le relevé
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReportPeriodModal;